<button buttonBasic (click)="clear()" class="text-m text-primary-500 px-1!">Clear</button>
